<template>
  <div class="campaign-notification" :class="themeClasses">
    <div class="campaign-notification__container">
      <div class="campaign-notification__message">
        <div class="campaign-notification__icon">
          <i class="fa" :class="`fa-${icon}`"></i>
        </div>
        <div v-if="title" class="campaign-notification__title">
          {{ title }}
        </div>
        <div v-if="heading" class="campaign-notification__heading">
          {{ heading }}
        </div>
        <div v-if="summary || !!$slots.summary" class="campaign-notification__summary">
          <slot name="summary">{{ summary }}</slot>
        </div>
        <div v-if="appLinks">
          <div class="campaign-notification__app-links">
            <a class="text-left" :href="mobileLink">
              <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' style="height: 60px;"/>
            </a>
            <a :href="mobileLink" style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2018-10-06&kind=iossoftware&bubble=ios_apps) no-repeat;width:135px;height:40px;margin-top:10px;"></a>
          </div>
        </div>
      </div>
      <div v-if="hasButtons" class="campaign-notification__buttons">
        <slot name="buttons">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    summary: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'dark'
    },
    icon: {
      type: String,
      default: 'money'
    },
    appLinks: {
      type: Boolean,
      default: false
    },
    hasButtons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    themeClasses () {
      const isDark = this.theme === 'dark'
      const isLight = this.theme === 'light'
      return {
        'campaign-notification--dark': isDark,
        'campaign-notification--light': isLight
      }
    }
  }
}
</script>
